"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.findColumnSettings = findColumnSettings;
exports.getFields = exports.getColumns = exports.getColumnLengths = exports.getColumnLabels = exports.findEmptyColumns = void 0;
exports.getLabel = getLabel;
exports.valueAccessor = exports.getStructureSettings = exports.getSourceField = exports.getRowFields = void 0;
var _lodash = _interopRequireDefault(require("lodash.union"));
var _lodash2 = _interopRequireDefault(require("lodash.get"));
var _constants = require("../constants");
var _strings = require("../../format/strings");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/prefer-default-export */

const onOffRegex = /^(.*)((Off)|(On))$/;
function cleanName(name) {
  if (onOffRegex.test(name)) {
    const groups = onOffRegex.exec(name);
    return {
      name: groups[1],
      type: onOffRegex.exec(name)[2]
    };
  }
  return {
    name
  };
}
function getLabel(name, labels) {
  let shouldReturnDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const {
    name: cleanedName,
    type
  } = cleanName(name);
  const {
    [cleanedName]: label = {}
  } = labels;
  if (name === 'alCPResistance') {
    return "AL CP Resistance";
  }
  const {
    Label = shouldReturnDefault ? (0, _strings.toCapitalCase)(name) : undefined
  } = label;
  if (type && Label !== undefined) {
    return `${Label} ${type}`;
  }
  return Label;
}
const getSourceField = approvalMode => {
  const sourceFields = ['_source.item', '_source.preapproval.item'];
  if (approvalMode === _constants.APPROVAL_MODE.approved) {
    return sourceFields[0];
  }
  if (approvalMode === _constants.APPROVAL_MODE.unapproved) {
    return sourceFields[1];
  }
  return sourceFields;
};
exports.getSourceField = getSourceField;
function getLabels(row) {
  const {
    _source: {
      labels = {}
    }
  } = row;
  return labels;
}
function getLength(value) {
  if (value === undefined) {
    return 0;
  }
  if (value === null) {
    return 0;
  }
  if (value === 'not set') {
    return 0;
  }
  return value.toString().length;
}
const getRowFields = (row, approvalMode) => {
  const sourceField = getSourceField(approvalMode);
  const item = (0, _lodash2.default)(row, sourceField) || {};
  const labelsInfo = getLabels(row);
  return Object.keys(item).map(attr => {
    const label = getLabel(attr, labelsInfo, false);
    const labels = [];
    if (label) {
      labels.push(label);
    }
    const src = `${sourceField}.${attr}`;
    const value = (0, _lodash2.default)(row, src);
    const maxLength = getLength(value);
    return {
      attr,
      labels,
      src: [src],
      maxLength
    };
  });
};
exports.getRowFields = getRowFields;
function getMaxLength(len1, len2) {
  if (len1 > len2) {
    return len1;
  }
  return len2;
}
const getFields = (hits, approvalMode) => {
  return hits.reduce((acc, row) => {
    const rowFields = getRowFields(row, approvalMode);
    const missingFields = rowFields.filter(_ref => {
      let {
        attr
      } = _ref;
      return !acc.some(_ref2 => {
        let {
          attr: a
        } = _ref2;
        return a === attr;
      });
    });
    const existingFields = rowFields.filter(_ref3 => {
      let {
        attr
      } = _ref3;
      return acc.some(_ref4 => {
        let {
          attr: a
        } = _ref4;
        return a !== attr;
      });
    });
    // console.log(existingFields);
    return [...acc.map(field => {
      const {
        labels,
        maxLength
      } = field;
      const existingField = existingFields.find(f => field.attr === f.attr);
      if (!existingField) {
        return field;
      }
      return {
        ...field,
        labels: (0, _lodash.default)(labels, existingField.labels),
        maxLength: getMaxLength(maxLength, existingField.maxLength)
      };
    }), ...missingFields];
  }, []);
};
exports.getFields = getFields;
function getRegEx(column) {
  const {
    name,
    regEx
  } = column;
  const regex = new RegExp(`^${regEx || name.replace('_source.item.', '')}$`);
  return regex;
}
function getMatch(column, field) {
  if (column === undefined) {
    return undefined;
  }
  const regex = getRegEx(column);
  const match = regex.exec(field);
  return match;
}
function findColumn(settings, field) {
  return settings.find(column => {
    if (Array.isArray(column)) {
      return findColumn(column, field);
    }
    const match = getMatch(column, field);
    if (match !== null) {
      return field;
    }
    return undefined;
  });
}
function applyMatch(str, match) {
  return Object.keys(match.groups).reduce((acc, group) => {
    const regEx = new RegExp(`\\\${${group}}`);
    return acc.replace(regEx, match.groups[group]);
  }, str);
}
function cleanColumn(field, column, match) {
  if (!column) {
    return column;
  }
  const {
    xlsTitle,
    corTitle
  } = column;
  if (/\${.*}/.test(xlsTitle) || /\${.*}/.test(corTitle)) {
    return {
      ...column,
      xlsTitle: applyMatch(xlsTitle, match),
      corTitle: applyMatch(corTitle, match)
    };
  }
  return column;
}
function findColumnSettings(settings, field) {
  const column = findColumn(settings, field);
  const index = settings.indexOf(column);
  if (Array.isArray(column)) {
    const colSettings = findColumnSettings(settings[index], field);
    return {
      ...colSettings,
      index: [{
        index,
        len: settings.length
      }, ...colSettings.index]
    };
  }
  const match = getMatch(column, field);
  // const { corTitle , xlsTitle} = column;
  // console.log(corTitle , xlsTitle, match);
  return {
    index: [{
      index,
      len: settings.length
    }],
    column: cleanColumn(field, column, match),
    match
  };
}
function checkNegativeOne(value) {
  if (value === -1) {
    return 1000;
  }
  return value;
}
function getFieldsSettings(hitFields, columnSettings) {
  const mapping = hitFields.map(_ref5 => {
    let {
      attr,
      ...rest
    } = _ref5;
    const settings = findColumnSettings(columnSettings, attr);
    return {
      field: attr,
      ...rest,
      ...settings
    };
  });
  return mapping;
}

// only works for 2 deep
function getSortNumber(field, index) {
  const [idx, ...rest] = index;
  const num = checkNegativeOne(idx.index);
  if (rest.length > 0) {
    const [subIdx] = rest;
    const {
      match
    } = field;
    const {
      groups: {
        num: groupNum = 0
      } = {}
    } = match;
    const subSortNum = subIdx.len * Number(groupNum) + subIdx.index;
    return num + subSortNum * 0.0001;
  }
  return num;
}
function getCombinedFieldsSettings(fieldsSettings) {
  return fieldsSettings.reduce((acc, fieldSettings) => {
    const {
      column: {
        regEx
      } = {},
      match: {
        groups: {
          num: number = 0
        } = {}
      } = {}
    } = fieldSettings;
    const existingSettings = acc.find(_ref6 => {
      let {
        column: {
          regEx: regex
        } = {},
        match: {
          groups: {
            num = 0
          } = {}
        } = {}
      } = _ref6;
      if (!regex) {
        return false;
      }
      return regex === regEx && num === number;
    });
    if (!existingSettings) {
      return [...acc, {
        ...fieldSettings,
        fields: [fieldSettings.field]
      }];
    }
    const {
      fields: existingFields = [],
      labels: existingLabels = [],
      src: existingSrc = [],
      maxLength: existingMaxLength
    } = existingSettings;
    return [...acc.slice(0, acc.length - 1), {
      ...existingSettings,
      labels: (0, _lodash.default)(existingLabels, fieldSettings.labels),
      src: (0, _lodash.default)(existingSrc, fieldSettings.src),
      fields: [...existingFields, fieldSettings.field],
      maxLength: getMaxLength(existingMaxLength, fieldSettings.maxLength)
    }];
  }, []);
}
const getColumnLabel = column => {
  const {
    column: {
      xlsTitle
    } = {},
    field,
    labels
  } = column;
  const capitalCase = (0, _strings.toCapitalCase)(field.substring(field.lastIndexOf('.') + 1));
  if (labels && labels.length > 0) {
    return labels.join('/');
  }
  if (xlsTitle) {
    return xlsTitle;
  }
  return capitalCase;
};
const getColumns = (hits, managerSettings, approvalMode) => {
  // console.time('getColumns');
  const hitFields = getFields(hits, approvalMode);
  const {
    columns: columnSettings = []
  } = managerSettings || {};
  const fieldsSettings = getFieldsSettings(hitFields, columnSettings);
  fieldsSettings.sort((field1, field2) => {
    const num1 = getSortNumber(field1, field1.index);
    const num2 = getSortNumber(field2, field2.index);
    if (num1 === 1000 && num2 === 1000) {
      const label1 = getColumnLabel(field1);
      const label2 = getColumnLabel(field2);
      if (label1 < label2) {
        return -1;
      }
      if (label1 > label2) {
        return +1;
      }
    }
    return num1 - num2;
  });
  const combinedFieldsSettings = getCombinedFieldsSettings(fieldsSettings);
  const columnsWithLabel = combinedFieldsSettings.map(column => ({
    ...column,
    label: getColumnLabel(column)
  }));
  // console.timeEnd('getColumns');
  return columnsWithLabel;
};
exports.getColumns = getColumns;
const findEmptyColumns = (hits, managerSettings, approvalMode) => {
  const columns = getColumns(hits, managerSettings, approvalMode);
  const emptyFields = columns.filter(column => {
    return !hits.some(row => {
      return column.src.some(s => {
        const value = (0, _lodash2.default)(row, s);
        return value !== undefined && value !== null && value !== 'not set' && value !== '';
      });
    });
  });
  return emptyFields;
};
exports.findEmptyColumns = findEmptyColumns;
const getColumnLabels = (hits, managerSettings, approvalMode) => {
  const columns = getColumns(hits, managerSettings, approvalMode);
  const columnLabels = columns.map(_ref7 => {
    let {
      field,
      xlsTitle,
      labels
    } = _ref7;
    return {
      field,
      xlsTitle,
      capitalCase: (0, _strings.toCapitalCase)(field),
      labels
    };
  });
  return columnLabels;
};
exports.getColumnLabels = getColumnLabels;
const getColumnLengths = (hits, managerSettings, approvalMode) => {
  const columns = getColumns(hits, managerSettings, approvalMode);
  const columnLengths = columns.map(_ref8 => {
    let {
      field,
      maxLength
    } = _ref8;
    // console.log(name);
    return {
      name: field,
      maxLength
    };
  });
  return columnLengths;
};
exports.getColumnLengths = getColumnLengths;
function isHistory(originalRow) {
  const {
    _index
  } = originalRow;
  if (_index === undefined) {
    return true;
  }
  if (_index.indexOf('histor') > -1) {
    return true;
  }
  return false;
}
function cleanSource(src) {
  let history = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (src === undefined) {
    return src;
  }
  if (history) {
    return src.replace('.preapproval', '');
  }
  return src;
}
function getSourceName(original, sources) {
  let column = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    column: {
      regEx
    } = {},
    match: {
      groups: {
        num
      } = {}
    } = {}
  } = column;
  const history = isHistory(original);
  const src = sources.find(s => (0, _lodash2.default)(original, cleanSource(s, history)) !== undefined);
  if (src === undefined) {
    if (history && regEx && num) {
      const hitFields = getRowFields(original, _constants.APPROVAL_MODE.approved);
      const field = hitFields.find(_ref9 => {
        let {
          attr
        } = _ref9;
        const newMatch = getMatch({
          regEx
        }, attr);
        if (newMatch === null) {
          return false;
        }
        const {
          groups: {
            num: newNum
          } = {}
        } = newMatch;
        return newNum === num;
      });
      if (field && field.src) {
        return getSourceName(original, field.src);
      }
    }
    return src;
  }
  if (history) {
    return src.replace('.preapproval', '');
  }
  return src;
}
const valueAccessor = (originalRow, sources, columnIndx, column) => {
  const {
    _source: {
      classCode: cCode
    } = {}
  } = originalRow;
  if (isHistory(originalRow)) {
    if (cCode === _constants.DOWNLOADING_TEXT) {
      if (columnIndx === 0) {
        return _constants.DOWNLOADING_TEXT;
      }
      return '';
    }
    const src = getSourceName(originalRow, sources, column);
    if (src === undefined) {
      return '';
    }
    return (0, _lodash2.default)(originalRow, src);
  }
  const src = getSourceName(originalRow, sources);
  if (src === undefined) {
    return '';
  }
  const value = (0, _lodash2.default)(originalRow, src);
  return value;
};
exports.valueAccessor = valueAccessor;
const getStructureSettings = (managerSettings, name) => {
  const [structureSettings] = managerSettings.filter(_ref10 => {
    let {
      name: _name
    } = _ref10;
    return _name === name;
  });
  if (!structureSettings && name !== 'default') {
    return getStructureSettings(managerSettings, 'default');
  }
  return structureSettings;
};
exports.getStructureSettings = getStructureSettings;
var _default = {
  getSourceField,
  getRowFields,
  getFields,
  findColumnSettings,
  getColumns,
  findEmptyColumns,
  getColumnLabels,
  getColumnLengths,
  valueAccessor,
  getStructureSettings,
  getLabel
};
exports.default = _default;